// Sensor Device Type Templates

import { Template01_Dashboard } from './Template01_Dashboard';

export { Template01_Dashboard } from './Template01_Dashboard';

// Template registry for dynamic selection
export const SensorTemplates = {
  Template01: () => import('./Template01_Dashboard').then(m => m.Template01_Dashboard),
} as const;

// Default export
export default Template01_Dashboard;
